import { Component, Input } from '@angular/core';

import { tipoVendaOutro } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-outro',
    templateUrl: './config-pedido-tipo-venda-badge-outro.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-outro.component.less']
})
export class ConfigPedidoTipoVendaBadgeOutroComponent {
    tipo = tipoVendaOutro;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
